const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.paymentContainer.paymentFlowsConfiguration.';

const FETCHING_DESCRIPTION = `${DOMAIN}fetchingDescription`,
  FETCHING_TITLE = `${DOMAIN}fetchingTitle`,
  PAYMENT_TITLE = `${DOMAIN}landingTitle`;

export { FETCHING_DESCRIPTION, FETCHING_TITLE, PAYMENT_TITLE };
